import React, { useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useSetState from '../../hooks/useSetState';
import Select from 'react-select';
import { fetchAllMenuCategories } from '../../redux/menuCategories/actions';

const MenuItemsFilter = ({ applyFilters, getAllCategories }) => {
  const { menuCategoriesList } = useSelector(state => ({
    menuCategoriesList: state.menuCategoriesReducer.menuCategoriesList,
  }));

  const dispatch = useDispatch();

  let formRefrence = useRef();

  const [controls, setControls] = useSetState({
    categoryIds: [],
    menuItemTitle: '',
    pageNumber: 1,
    pageSize: 1000,
  });

  const onChangeValue = (controleName, value) => {
    setControls({ [controleName]: value });
  };

  const categoryList = menuCategoriesList => {
    const listItems = menuCategoriesList.map(category => ({
      label: category.title,
      value: category.id,
    }));
    return listItems;
  };
  const onSubmit = event => {
    event.preventDefault();
    applyFilters(event, controls.categoryIds);
  };

  const onReset = () => {
    onChangeValue('categoryIds', '');
    onChangeValue('menuItemTitle', '');
    getAllCategories();
  };

  useEffect(() => {
    // let query =`pageNumber=${controls.pageNumber}&pageSize=${controls.pageSize}`
    dispatch(fetchAllMenuCategories());
  }, []);

  return (
    <section>
      <form
        ref={formRefrence}
        onSubmit={event => onSubmit(event)}
        id='filterForm'
        className='card card my-4'
      >
        <header className='text-center card-header'>
          <h5 className='font-italic text-muted'>{locales('titles.filter')}</h5>
        </header>
        <main className='card-body'>
          <div className='d-flex row flex-sm-column col-12 flex-md-row px-1 mx-1'>
            <div className='form-group d-flex col-lg-5 col-md-12 col-sm-12 mx-1'>
              <label className='rsee-form-label col-md-5'>
                {locales('tables.menuCategoryTitle')}
              </label>
              <div className='full-width'>
                <Select
                  id='categoryIds'
                  name='categoryIds'
                  placeholder={locales('tables.category')}
                  isMulti={true}
                  value={controls.categoryIds}
                  options={categoryList(menuCategoriesList)}
                  onChange={selectedCategoryIds => {
                    onChangeValue('categoryIds', selectedCategoryIds);
                  }}
                />
              </div>
            </div>
            <div className='form-group d-flex col-lg-5 col-md-12 col-sm-12 mx-1'>
              <label className='rsee-form-label col-md-5'>
                {locales('labels.item')}
              </label>
              <div className='full-width'>
                <input
                  name='menuItemTitle'
                  type='text'
                  className='form-control'
                  value={controls.menuItemTitle}
                  onChange={event =>
                    onChangeValue('menuItemTitle', event.value)
                  }
                />
              </div>
            </div>
          </div>

          <div className='col-12 d-flex justify-content-end p-0 my-3'>
            <button
              type='button'
              onClick={onReset}
              className='btn btn-danger w-5 mx-2'
            >
              {locales('fields.reset')}
            </button>
            <button type='submit' className='btn btn-success w-5 mx-2'>
              {locales('fields.applyFilters')}
            </button>
          </div>
        </main>
      </form>
    </section>
  );
};

export default MenuItemsFilter;
